"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationWorkingDayTime_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var RecordStatus_1 = require("./RecordStatus");
var LocationWorkingDayTime_Factory = /** @class */ (function () {
    function LocationWorkingDayTime_Factory() {
    }
    LocationWorkingDayTime_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            EndTime: Date_Factory_1.Date_Factory.CreateIncoming(model.EndTime),
            LocationWorkingDayId: model.LocationWorkingDayId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RecordStatus1: RecordStatus_1.RecordStatus_Factory.CreateIncoming(model.RecordStatus1),
            StartTime: Date_Factory_1.Date_Factory.CreateIncoming(model.StartTime),
        };
        return result;
    };
    LocationWorkingDayTime_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            EndTime: Date_Factory_1.Date_Factory.CreateOutgoing(model.EndTime),
            LocationWorkingDayId: model.LocationWorkingDayId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RecordStatus1: RecordStatus_1.RecordStatus_Factory.CreateOutgoing(model.RecordStatus1),
            StartTime: Date_Factory_1.Date_Factory.CreateOutgoing(model.StartTime),
        };
        return result;
    };
    return LocationWorkingDayTime_Factory;
}());
exports.LocationWorkingDayTime_Factory = LocationWorkingDayTime_Factory;
